import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ConnectProvider } from './context/ConnectContext';
import { AuthProvider } from './context/AuthContext';
import { TourProvider } from './context/TourContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ConnectModal from './components/ConnectModal';
import ScrollToTop from './components/ScrollToTop';
import AuthCallback from './components/AuthCallback';
import ProtectedRoute from './components/ProtectedRoute';
import TourGuide from './components/TourGuide';
import Home from './pages/Home';
import WhatWeOffer from './pages/WhatWeOffer';
import InvestmentOpportunities from './pages/InvestmentOpportunities';
import OurGrowth from './pages/OurGrowth';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import Marketplace from './pages/Marketplace';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import InvestorOverview from './pages/InvestorOverview';

function Layout() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-offer" element={<WhatWeOffer />} />
          <Route path="/investment-opportunities" element={<InvestmentOpportunities />} />
          <Route path="/our-growth" element={<OurGrowth />} />
          <Route path="/login" element={<Login />} />
          <Route path="/investor-overview" element={<InvestorOverview />} />
          <Route path="/dashboard" element={<ProtectedRoute kyc><Dashboard /></ProtectedRoute>} />
          <Route path="/marketplace" element={<ProtectedRoute kyc><Marketplace /></ProtectedRoute>} />
          <Route path="/notifications" element={<ProtectedRoute kyc><Notifications /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute kyc><Reports /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
      <ConnectModal />
      <TourGuide />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-farmway-green">
      <BrowserRouter>
        <AuthProvider>
          <ConnectProvider>
            <TourProvider>
              <Layout />
              <Toaster position="top-center" richColors theme="dark" />
            </TourProvider>
          </ConnectProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
